import _ from "lodash";
import { combineReducers } from "redux";
import loginReducer from "routes/modules/LoginModule/LoginReducer";
import servicesReducer from "modules/Services/ServicesReducer";
import navigationReducer from "modules/NavigationModule/NavigationReducer";
import coachmarksReducer from "modules/CoachMarksModule/CoachMarksReducer";
import pusherReducer from "modules/PusherModule/PusherReducer";
import platformReducer from "Platform/modules/PlatformModule/PlatformReducer";
import ResourceBankReducer from "modules/ResourceBankModule/ResourceBankReducer";
import conversationReducer from "ChatContainer/modules/ChatContainerModule/ChatContainerReducer";
import myCalendarReducer from "MyCalendar/modules/MyCalendarModule/MyCalendarReducer";
import { loadingBarReducer } from "react-redux-loading-bar";
import AssessmentReducer from "Assessments/modules/AssessmentModule/AssessmentReducer";
import OrganizationResourcesReducer from "OrganizationResources/modules/OrganizationResourcesModule/OrganizationResourcesReducer";
import UnitPlansReducer from "UnitPlans/modules/UnitPlanModule/UnitPlanReducer";
import InternalToolsModalReducer from "AppComponents/InternalToolsModal/modules/InternalToolsModalReducer";

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    // Add sync reducers here
    // apollo:client.reducer(),
    login: loginReducer,
    app_services: servicesReducer,
    navigation: navigationReducer,
    coachMarks: coachmarksReducer,
    loadingBar: loadingBarReducer,
    pusher: pusherReducer,
    resourceBank: ResourceBankReducer,
    conversation: conversationReducer,
    myCalendar: myCalendarReducer,
    platform: platformReducer,
    assessment: AssessmentReducer,
    organizationResource: OrganizationResourcesReducer,
    unitPlans: UnitPlansReducer,
    internal_tools: InternalToolsModalReducer,
    ...asyncReducers,
  });
};
export const injectReducer = (store, { key, reducer }) => {
  if (!_.has(store.asyncReducers, key)) {
    store.asyncReducers[key] = reducer;
    store.replaceReducer(makeRootReducer(store.asyncReducers));
  }
};
export default makeRootReducer;
